module.exports = __webpack_public_path__ + "img/[调皮].10eae7a0.svg";